import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onLocationSelected", "onLocationUpdateLoading", "onLocationUpdateError", "onLocationUpdateCompleted"];
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useEffect, useRef } from "react";
import { retry } from "@catchoftheday/utilities";
import { useUpdateUserLocationMutation, useUserLocationQuery } from "../../generated/graphql.jsx";
import { formatLocation, LocationWidget } from "../LocationWidget/index.js";
import { jsx as ___EmotionJSX } from "@emotion/react";
export function UserLocationWidget(_ref) {
  var _ref2;

  var onLocationSelected = _ref.onLocationSelected,
      onLocationUpdateLoading = _ref.onLocationUpdateLoading,
      onLocationUpdateError = _ref.onLocationUpdateError,
      onLocationUpdateCompleted = _ref.onLocationUpdateCompleted,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useUserLocationQuery = useUserLocationQuery(),
      query = _useUserLocationQuery.data;

  var userLocation = query === null || query === void 0 ? void 0 : query.userLocation;
  var initialLocationModel = userLocation && "location" in userLocation ? userLocation.location : undefined;
  var initialLocationDisplay = (_ref2 = initialLocationModel && formatLocation(initialLocationModel)) !== null && _ref2 !== void 0 ? _ref2 : undefined;
  var initialLocationSet = useRef(false); // Set user's current location

  var _useUpdateUserLocatio = useUpdateUserLocationMutation(),
      _useUpdateUserLocatio2 = _slicedToArray(_useUpdateUserLocatio, 1),
      _updateUserLocation = _useUpdateUserLocatio2[0];

  var updateUserLocation = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id, location) {
      var locationId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onLocationSelected === null || onLocationSelected === void 0 ? void 0 : onLocationSelected(id, location);

              if (id) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              locationId = "".concat(id);
              _context.prev = 4;
              onLocationUpdateLoading && onLocationUpdateLoading();
              _context.next = 8;
              return retry(_updateUserLocation)({
                variables: {
                  input: {
                    locationId: locationId
                  }
                },
                onCompleted: function onCompleted(data) {
                  onLocationUpdateCompleted && onLocationUpdateCompleted();
                }
              });

            case 8:
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](4);
              onLocationUpdateError && onLocationUpdateError();

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 10]]);
    }));

    return function updateUserLocation(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }(); // Once the initial location is set, call the selected callback.


  useEffect(function () {
    // Ensure onLocationSelected is only invoked once, when initial location is fetched
    if (!initialLocationModel || initialLocationSet.current) return;
    initialLocationSet.current = true;
    onLocationSelected === null || onLocationSelected === void 0 ? void 0 : onLocationSelected(initialLocationModel.id, initialLocationModel);
  }, [initialLocationModel, onLocationSelected]); // Using `key` to force re-render as a new component when initialLocationDisplay changes.

  return ___EmotionJSX(LocationWidget, _extends({
    key: initialLocationDisplay ? "default" : "with-location"
  }, rest, {
    initialLocation: initialLocationDisplay,
    onLocationSelected: updateUserLocation
  }));
}